import React, { useState } from 'react'
import { InsufficientPermissions, Loading } from '../common'
import { getAuthUser } from '../../helpers'
import defineAbilityFor from './defineAbility'

enum PageState {
    Default,
    Loading,
    Found,
    NotFound,
    Error,
}

export const ArcLocatorComponent = () => {
    const [arc, setArc] = useState('')
    const [agencyInfo, setAgencyInfo] = useState<any[] | null>(null)
    const [pageState, setPageState] = useState(PageState.Default)
    const ability = defineAbilityFor(getAuthUser())

    const handleSubmit = async (arc: string) => {
        {/* exposed API endpoint to fetch agency info by ARC number from the website  */}
        const url = `https://www2.arccorp.com/Tamis/GetAgenciesByAcn?acn=${arc}`

        try {
            setPageState(PageState.Loading)

            const response = await fetch(url)

            if (!response.ok) {
                if (response.status === 404) {
                    setPageState(PageState.NotFound)
                } else {
                    setPageState(PageState.Error)
                }
                return
            }

            const data = await response.json()

            if (!data || data.length === 0) {
                setPageState(PageState.NotFound)
                return
            }

            setAgencyInfo(data)
            setPageState(PageState.Found)
        } catch (err: any) {
            console.error(err)
            setPageState(PageState.Error)
        }
    }

    const result = () => {
        switch (pageState) {
            case PageState.Loading:
                return (
                    <div className="container">
                        <Loading />
                    </div>
                )

            case PageState.Error:
                return (
                    <div className="container">
                        <p>Something went wrong. Please try again.</p>
                    </div>
                )

            case PageState.NotFound:
                return (
                    <div className="container">
                        <p>Agency Arc not found.</p>
                    </div>
                )

            case PageState.Found:
                return (
                    agencyInfo &&
                    agencyInfo.length > 0 && (
                        <>
                            {agencyInfo.map((agency, id) => (
                                <div key={id} className="card p-3 mt-3">
                                    <h5 className="mb-2">{agency.TradeName}</h5>
                                    <p>
                                        <strong>ARC #:</strong> {agency.AgtAcn}
                                    </p>
                                    <p>
                                        <strong>Address:</strong>
                                        <br />
                                        {agency.Address1 || ''} {agency.Address2 || ''}
                                        <br />
                                        {agency.City}, {agency.State} {agency.ZipCode}
                                    </p>
                                    <p>
                                        <strong>Phone:</strong> {agency.AgtPhone || 'N/A'}
                                    </p>
                                    <p>
                                        <strong>Status:</strong>{' '}
                                        {agency.AgtStatus === '0' ? 'Active' : 'Inactive'}
                                    </p>
                                </div>
                            ))}
                        </>
                    )
                )
            case PageState.Default:
            default:
                return null
        }
    }

    if (!ability.can('View', 'Agency')) {
        return <InsufficientPermissions />
    }

    return (
        <div className="container">
            <form
                onSubmit={(e) => {
                    e.preventDefault()
                    handleSubmit(arc)
                }}
            >
                <div className="row">
                    <div className="col-6">
                        <h3>Arc Locator</h3>
                        <input
                            className="form-control mb-3"
                            id="arcLocatorInput"
                            placeholder="Search by ARC Number"
                            value={arc}
                            onChange={(e) => setArc(e.target.value)}
                            required
                            type="text"
                        />
                        <span className="d-flex mt-3">
                            <button
                                className="btn btn-primary"
                                type="submit"
                                disabled={pageState === PageState.Loading}
                            >
                                {pageState === PageState.Loading ? 'Searching...' : 'Submit'}
                            </button>
                        </span>
                    </div>
                </div>
            </form>
            <div className="mt-4">{result()}</div>
        </div>
    )
}
